"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classnames = require("classnames");
class Callout extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.classNamesByStyle = {
            danger: 'vf-callout-danger',
            alert: 'vf-callout-alert',
            ok: 'vf-callout-ok'
        };
    }
    render() {
        const { className, style, full, children } = this.props;
        const classes = classnames('vf-callout', className, this.classNamesByStyle[style], { 'vf-callout--full': full });
        return (React.createElement("div", { className: classes }, children));
    }
}
exports.default = Callout;
